import React, { Component, Fragment } from 'react'
import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

const formatNumber = {
  separador: ',', // separador para los miles
  sepDecimal: '.', // separador para los decimales
  formatear: function (num) {
    num += '';
    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    let regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return this.simbol + splitLeft + splitRight;
  },
  new: function (num, simbol) {
    this.simbol = simbol || '';
    if (typeof num == 'undefined') {
      num = 0;
    }
    if (isNaN(num)) {
      return num;
    }
    return this.formatear(Number(num).toFixed(2));
  },
};

class AdvancePaymentInvoiceDoc extends Component {

 

  RefreshDocModel = async (EditableDocModel) => {
    const { RefreshDocModel } = this.props;
    await RefreshDocModel(EditableDocModel);
    this.forceUpdate();
  }

  OnchangeBillStreet = async (value) => {
    const { EditableDocModel } = this.props;
    EditableDocModel.street = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillCounty = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.county = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillCity = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.city = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillBlock = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.block = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeRFC = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.rfc = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipStreet = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipStreet = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipCounty = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipCounty = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipCity = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipCity = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipBlock = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipBlock = value;
    this.RefreshDocModel(EditableDocModel)
  }

  EqualDataToNewDataModel = () => {
    const { EditableDocModel, BillAddress, ShipAddress, DocHeader } = this.props;
    EditableDocModel.street = BillAddress.Street ?? '';
    EditableDocModel.county = BillAddress.County ?? '';
    EditableDocModel.city = BillAddress.City ?? '';
    EditableDocModel.block = BillAddress.Block ?? '';
    EditableDocModel.zipCode = BillAddress.ZipCode ?? '';

    EditableDocModel.shipStreet = ShipAddress.Street ?? '';
    EditableDocModel.shipCounty = ShipAddress.County ?? '';
    EditableDocModel.shipCity = ShipAddress.City ?? '';
    EditableDocModel.shipBlock = ShipAddress.Block ?? '';
    EditableDocModel.shipZipCode = ShipAddress.ZipCode ?? '';

    EditableDocModel.rfc = DocHeader.LicTradNum ?? '';
    this.RefreshDocModel(EditableDocModel)
  }

  async componentDidUpdate(prevProps) {
    if (this.props.EditableMode !== prevProps.EditableMode) {
      await this.EqualDataToNewDataModel();
      return true;
    }
  }

  timeFormat = () => {
    const { DocHeader } = this.props;
    let timeFormat = '';
    if (DocHeader.CreateTS) {
      let time = (DocHeader.CreateTS || '').toString();
      if (time.length > 0) {
        let seconds = time.length - 2;
        let minutes = time.length - 4;
        timeFormat = time.slice(0, minutes) + ":" + time.slice(minutes, seconds) + ":" + time.slice(seconds, time.length)
      }
    }
    return timeFormat;
  }

  ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, countPages, folio, nextFolio){
    return(
      <table><tr><td>
          <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
            <div className='text-right' style={{fontSize:"14px"}}>
              <table>
                  <tbody>
                      <tr>
                          <td className='text-left'>
                              {folio}
                          </td>
                          <td className='text-right'>
                          {nextFolio+" - "}Pagina {countPages+2}/{Math.trunc((DocLines.length - linesfirstPage) / linesfullPage)+2}
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div className='row' style={{ paddingRight: "15px" }}>
              <table className='mt-2'>
                <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                  <tr>
                    <th>Cant.</th>
                    <th>UMV</th>
                    <th>CVE</th>
                    <th>Cve P/S</th>
                    <th className="text-center">Código</th>
                    <th className="text-center">Descripción</th>
                    <th className="text-center">Tasa</th>
                    <th className="text-right">Precio U</th>
                    <th className="text-right">Importe</th>
                    {/* <th className="text-center">Descuento %</th> */}
                    <th className="text-right">Importe N.</th>
                  </tr>
                </thead>
                <tbody style={{ border: "solid 1px" }}>
                  {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                    DocLines.map((docLine) => {//51 es el limite de la primera pagina
                      if ((countLines2> linesfirstPage + (linesfullPage * countPages)) &&  (countLines2< linesfirstPage + (linesfullPage * (countPages+1)))) {
                        countLines2++
                        return (
                          <tr style={{ fontSize: '12px' }}>
                            <td>{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                            <td>{docLine.SalUnitMsr ?? ''}</td>
                            <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                            <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                            <td className="text-center">{docLine.ItemCode ?? ''}</td>
                            <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                            <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                            <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                            <td className="text-right">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                            {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(2) ?? 0}%</td> */}
                            <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                          </tr>
                        );
                      }else{
                        countLines2++
                        return(<></>);
                      }
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
      </td></tr></table>
    );
  }
  taxSystem = (key) => {
    let name="";
    switch (key) {
      case "601":
        name = "General de Ley Personas Morales"
      break;
  
      case "603":
        name = "Personas Morales con Fines no Lucrativos"
      break;
  
      case "605":
        name = "Sueldos y Salarios e Ingresos Asimilados a Salarios"
      break;
  
      case "606":
        name = "Arrendamiento"
      break;
  
      case "607":
        name = "Régimen de Enajenación o Adquisición de Bienes"
      break;
  
      case "608":
        name = "Demás ingresos"
      break;
  
      case "610":
        name = "Residentes en el Extranjero sin Establecimiento Permanente en México"
      break;
  
      case "611":
        name = "Ingresos por Dividendos (socios y accionistas)"
      break;
  
      case "612":
        name = "Personas Físicas con Actividades Empresariales y Profesionales"
      break;
  
      case "614":
        name = "Ingresos por intereses"
      break;
  
      case "615":
        name = "Régimen de los ingresos por obtención de premios"
      break;
  
      case "616":
        name = "Sin obligaciones fiscales"
      break;
  
      case "620":
        name = "Sociedades Cooperativas de Producción que optan por diferir sus ingresos"
      break;
  
      case "621":
        name = "Incorporación Fiscal"
      break;
  
      case "622":
        name = "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras"
      break;
  
      case "623":
        name = "Opcional para Grupos de Sociedades"
      break;
  
      case "624":
        name = "Coordinados"
      break;
  
      case "625":
        name = "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas"
      break;
  
      case "626":
        name = "Régimen Simplificado de Confianza"
      break;
    
      default:
        break;
    }
    return name;
  }

  render() {
    const { EditableMode, DocLines, DocHeader, EditableDocModel, BillAddress, ShipAddress, EditParam1, user, InfoByFolio} = this.props;

    let linesForAllInOne =10;
    let linesfirstPage = 51;
    let linesfullPage = 71;

    let remainingLines = (DocLines.length-linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length-linesfirstPage)/linesfullPage));
    let totalPages = Math.ceil( (DocLines.length - linesfirstPage) / linesfullPage );
    
    let countLines=1;
    let countLines2=1;

    let extraTables = [];
    
    for (let index = 0; index < totalPages; index++) {
        extraTables.push (this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio, (!!InfoByFolio.nextFolio ? InfoByFolio.nextFolio : "")))
    }
    let XML = {};
    let xml = DocHeader.U_FMB_XMLTIMBRA ? DocHeader.U_FMB_XMLTIMBRA.includes('UUID') ? JSON.parse(DocHeader.U_FMB_XMLTIMBRA) : null : null;
    XML ={
      isTimbra: xml ? true : false,
      info: xml
    }

    let filas = '';
    let cfdiRelacionados;
    let UUIDSustitutoTipo;
    if( cfdiRelacionados.length > 0){
      for (let index = 0; index < cfdiRelacionados.length; index++) {
          const uuid = cfdiRelacionados[index];
          filas+=`<label>${" - "+uuid._attributes.UUID+" - "}</label>\n`
      }
    }else{
        filas+=`<label>${" - "+cfdiRelacionados._attributes.UUID+" - "}</label>\n`
    }

    let cadenaQR = '';
    let cfdiCaComplemento = '';
    let totalLetra = '';
    let docType = '';
    if(xml){
      cadenaQR = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=` +
                  xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID + `&re=` +
                  xml.cfdiEmisor._attributes.Rfc + `&rr=` +
                  xml.cfdiReceptor._attributes.Rfc + `&tt=` +
                  xml._attributes.Total + `&fe=` +
                  xml._attributes.Sello.substring(xml._attributes.Sello.length - 8, xml._attributes.Sello.length);

    cfdiCaComplemento =
            "|" +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.Version +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.RfcProvCertif +
            "|" +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT +
            "|" +
            "|";

            let numeroLetra = new NumeroLetra();
            totalLetra = numeroLetra.NumeroALetras(xml._attributes.Moneda, Number(Number(DocHeader.DocTotal).toFixed(2)));
            docType = Number(DocHeader.ObjType) === 14 ? 'Nota de Crédito' : DocHeader ? DocHeader.IsIns === 'Y' ? 'Fac.Reserva' : 'Fac.Directa'  : 'Fac.Directa';
    }
       
    return (
      <>
      {/* Facturas con 10 o menos articulos */}
        {DocLines.length <= linesForAllInOne &&
          <table><tr><td>
            <div id="printInvoice" >
              <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
                {DocLines.length > linesForAllInOne && DocLines.length < 71? 
                  <div className='text-right' style={{fontSize:"14px"}}> {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina 1/2</div>
                  :
                  (DocLines.length > 71)&&<div className='text-right' style={{fontSize:"14px"}}> {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina 1/3</div>
                }
                <div className="row">
                  <div className="col-3">
                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />

                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />
                      {/* <span className="text-center">{user.Timbra.RFC || ''}</span><br /> */}
                      <strong>Folio: {InfoByFolio.folio || ''}</strong></p>

                    {/* <span className="text-left">Teléfono(s): {user.Branch.Phone || ''}</span> */}
                    <span className="text-left">Teléfono(s): 800 737 3469</span>
                    {/* <p className="text-center"><br/>{user.Branch.Address || ''}</p> */}
                    <p className="text-center"><br /></p>
                    {/* <p style={{ fontSize:'11px' }}>COL. C.P.;,.</p> */}
                  </div>
                  <div className="col-9">
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Serie</th>
                          <th className="text-center">Folio</th>
                          <th className="text-center">Número de certificado:</th>
                          <th className="text-center">Fecha - Hora emisión</th>
                          <th className="text-center">Lugar de expedición</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.Serie : ''}</td>
                          <td className="text-center">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.NoCertificado : ''}</td>
                          <td className="text-center">{`${XML.isTimbra ? XML.info._attributes.Fecha :''}`}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.LugarExpedicion : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Folio Fiscal:</th>
                          <th className="text-center">Certificado SAT:</th>
                          <th className="text-center">Fecha y Hora de Certificación:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center" style={{ fontsize: "3vw" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">No. Cliente:</th>
                          <th className="text-center">Uso CFDI</th>
                          <th className="text-center">Asesor de ventas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Nombre : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.UsoCFDI : ''}</td>
                          <td className="text-center">{DocHeader.SlpName || ''} </td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Tipo Documento</th>
                          <th className="text-center">Régimen</th>
                          <th className="text-center">R.F.C.</th>
                          <th className="text-center">Moneda</th>
                          <th className="text-center">Folio</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{docType}</td>
                          <td className="text-center">{!!DocHeader.U_FMB_REGIMEN_FISCAL && DocHeader.U_FMB_REGIMEN_FISCAL}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Rfc : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.Moneda : ''}</td>
                          <td className="text-center">{InfoByFolio.folio || ''}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row' style={{ paddingRight: "15px" }}>
                  <table>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th className="text-center" colSpan={2}>DOMICILIO DE FACTURACIÓN</th>
                        <th className="text-center" colSpan={2} style={{ width: "18.75vw" }}>Forma y método de pago</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderLeft: "solid 1px" }}>
                        <td className="text-center" colSpan={2}>
                          {true ?
                            (BillAddress === {} ?
                              (`${DocHeader.BillDirection}`)
                              :
                              // (`${BillAddress.County ?? ''}, ${BillAddress.City ?? ''}, ${BillAddress.ZipCode ?? ''}, ${BillAddress.Block ?? ''}, ${BillAddress.Street ?? ''}`)
                              (`${DocHeader.BillDirection}`)
                              )
                            :
                            <>
                              <table>
                                <thead>
                                  <tr>
                                    <th className="text-center">CALLE </th>
                                    <th className="text-center">ESTADO </th>
                                    <th className="text-center">CIUDAD </th>
                                    <th className="text-center">COLONIA </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style={{ borderLeft: "solid 1px" }}>
                                    <td className="text-center">
                                      <input type="text"
                                        placeholder='CALLE'
                                        value={EditableDocModel.street ?? ''}
                                        onChange={(event) => this.OnchangeBillStreet(event.target.value)}
                                      >
                                      </input>
                                    </td>
                                    <td className="text-center">
                                      <input type="text"
                                        placeholder='ESTADO'
                                        value={EditableDocModel.county}
                                        onChange={(event) => this.OnchangeBillCounty(event.target.value)}
                                      >
                                      </input>
                                    </td>
                                    <td className="text-center">
                                      <input type="text" placeholder='CIUDAD'
                                        value={EditableDocModel.city}
                                        onChange={(event) => this.OnchangeBillCity(event.target.value)}
                                      ></input>
                                    </td>
                                    <td className="text-center">
                                      <input type="text" placeholder='COLONIA'
                                        value={EditableDocModel.block}
                                        onChange={(event) => this.OnchangeBillBlock(event.target.value)}
                                      ></input></td>

                                  </tr>
                                </tbody>
                              </table>
                            </>
                          }
                        </td>
                        <td className="text-center" style={{ border: "solid 1px" }}>{XML.isTimbra ? XML.info._attributes.FormaPago : ''}</td>
                        <td className="text-center" style={{ border: "solid 1px" }}>{XML.isTimbra ? XML.info._attributes.MetodoPago : ''}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th className="text-center">DOMICILIO DE ENTREGA</th>
                        <th className="text-center" style={{ width: "300px" }}>Fecha de vencimiento</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderLeft: "solid 1px" }}>
                        <td className="text-center">
                          {true ?
                            (ShipAddress === {} ?
                              (`${DocHeader.ShipDirection}`)
                              :
                              (`${ShipAddress.County ?? ''}, ${ShipAddress.City ?? ''}, ${ShipAddress.ZipCode ?? ''}, ${ShipAddress.Block ?? ''}, ${ShipAddress.Street ?? ''}`) ||
                              (`${DocHeader.ShipDirection}`)
                            )
                            :
                            EditParam1 === true ?
                              <>
                                <table>
                                  <thead>
                                    <tr>
                                      <th className="text-center">CALLE </th>
                                      <th className="text-center">ESTADO </th>
                                      <th className="text-center">CIUDAD </th>
                                      <th className="text-center">COLONIA </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr style={{ borderLeft: "solid 1px" }}>
                                      <td className="text-center">
                                        <input type="text"
                                          placeholder='CALLE'
                                          value={EditableDocModel.shipStreet ? EditableDocModel.shipStreet : ''}
                                          onChange={(event) => this.OnchangeShipStreet(event.target.value)}
                                        >
                                        </input>
                                      </td>
                                      <td className="text-center">
                                        <input type="text"
                                          placeholder='ESTADO'
                                          value={EditableDocModel.shipCounty}
                                          onChange={(event) => this.OnchangeShipCounty(event.target.value)}
                                        >
                                        </input>
                                      </td>
                                      <td className="text-center">
                                        <input type="text" placeholder='CIUDAD'
                                          value={EditableDocModel.shipCity}
                                          onChange={(event) => this.OnchangeShipCity(event.target.value)}
                                        ></input>
                                      </td>
                                      <td className="text-center">
                                        <input type="text" placeholder='COLONIA'
                                          value={EditableDocModel.shipBlock}
                                          onChange={(event) => this.OnchangeShipBlock(event.target.value)}
                                        ></input></td>

                                    </tr>
                                  </tbody>
                                </table>
                              </>
                              :
                              ''
                          }
                        </td>
                        <td className="text-center" style={{ border: "solid 1px" }}>{!!DocHeader.DocDueDate && moment(DocHeader.DocDueDate).format("YYYY-MM-DD")}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr style={{ borderLeft: "solid 1px" }}>
                        <th className="text-center" ></th>
                        <th className="text-center" style={{ width: "300px", background: Datos_Empresa.BackgroundColor, color: "white" }}>Nombre del capturista</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderLeft: "solid 1px", borderBottom: "solid 1px" }}>
                        <td className="text-center"></td>
                        <td className="text-center" style={{ border: "solid 1px" }}>{DocHeader.U_FMB_User || ''}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className='mt-2'>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th>Cant.</th>
                        <th>UMV</th>
                        <th>CVE</th>
                        <th>Cve P/S</th>
                        <th className="text-center">Código</th>
                        <th className="text-center">Descripción</th>
                        <th className="text-center">Tasa</th>
                        <th className="text-right">Precio U</th>
                        <th className="text-right">Importe</th>
                        {/* <th className="text-center">Descuento %</th> */}
                        <th className="text-right">Importe N.</th>
                      </tr>
                    </thead>
                    <tbody style={{ border: "solid 1px" }}>
                      {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                        DocLines.map((docLine) => {//51 es el limite de la primera pagina
                          if (countLines < 52) {
                            countLines++
                            return (
                              <tr style={{ fontSize: '12px' }}>
                                <td>{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                                <td>{docLine.SalUnitMsr ?? ''}</td>
                                <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                                <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                                <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                                <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                                <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                                <td className="text-right">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                                {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(2) ?? 0}%</td> */}
                                <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                              </tr>
                            );
                          }else{
                            return("");
                          }
                        })
                      }
                    </tbody>
                  </table>
                </div>
                
                
                <div className="row" style={{paddingRight: "15px"}}>

                    <table className="mt-2">
                        <thead style={{background: Datos_Empresa.BackgroundColor, color: "white", fontSize: "8px"}}>
                            <tr>
                                <th className="text-center" colSpan="4">Documentos Relacionados</th>
                            </tr>
                        </thead>
                        <tbody style={{border: "1px solid"}}>
                            <tr style={{fontSize: "9px"}}>
                                <td className="text-center"><strong>Tipo Relación: </strong></td>
                                <td className="text-center">${UUIDSustitutoTipo}</td>
                                <td className="text-center"><strong>UUID: </strong></td>
                                <td className="text-center">${filas}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                               



                <div className='row mt-2'>
                  <div className='col-8'>
                    <p style={{ marginLeft: "-13px", fontSize: '12px' }}>
                      Comentarios:<br />
                      TODA DEVOLUCIÓN CAUSARÁ UN CARGO DEL 10% DEL TOTAL DE LA FACTURA POR GASTOS ADMINISTRATIVOS.<br />
                      NO ACEPTAMOS DEVOLUCIONES NI CANCELACIONES DESPUÉS DE 7 DÍAS, SIN EXCEPCIONES.<br />
                      EFECTOS FISCALES AL PAGO. ESTA FACTURA SERÁ PAGADA EN UNA SOLA EXHIBICIÓN. <br />
                      <strong>Régimen fiscal del receptor: {(!! DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "" )+ "-" + this.taxSystem(!! DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "")}.</strong><br />
                      {totalLetra} {XML.isTimbra ? XML.info._attributes.Moneda : ''}
                    </p>
                  </div>
                  <div className='col-4'>
                    <table>
                      <tbody style={{ fontSize: '12px' }}>
                        <tr>
                          <td className='text-right'><strong>Subtotal: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "6.25vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum)}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Descuento: %</strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{formatNumber.new(DocHeader.DiscPrcnt) ?? 0}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>IVA: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Retención: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{''}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>Total: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-center">Este documento es una impresión de un comprobante fiscal digital</th>
                          <th className="text-center">Este documento es una representación impresa de un CFDI</th>
                          <th className="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-left" colSpan={3}>
                            <strong>Sello digital autorizado:</strong><br />
                            <p class='digitalStamp' style={{ marginBottom: "-5px" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD : ''}</p>
                          </td>
                          <td className="text-center" rowSpan={2}>
                            <QRCodeSVG
                              value={cadenaQR}
                              height={92}
                              width={92}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left" colSpan={3}><strong>Sello digital SAT:</strong>
                            <p className='digitalStamp' style={{ marginBottom: "-5px" }}>
                              {XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloSAT : ''}
                            </p>
                          </td>

                        </tr>
                        <tr>
                          <td className="text-left" colSpan={4}>
                            <strong>Cadena original:</strong>
                            <p className='digitalStampAlt' style={{ marginBottom: "5px" }}>{cfdiCaComplemento}</p>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <p style={{ fontSize: '11px' }}>
                      {`Pagaré No.1 En ${DocHeader.U_FMB_LUGAREXPEDICION || ''}, a ${XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado : ''}. Bueno por ${CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}`} <br/>
                      {`Debo(emos) y pagaré(mos) incondicionalmente por este pagaré a la orden de ${Datos_Empresa.Nombre} ${Datos_Empresa.Sociedad},`}<br/>
                      {`Fecha pago: ${`${!!DocHeader.DocDate && moment(DocHeader.DocDate).format("YYYY-MM-DD")}`}.`}<br />
                    </p>
                    <p style={{ fontSize: '11px' }}>
                      {`La cantidad de: ${totalLetra} ${XML.isTimbra ? XML.info._attributes.Moneda : ''}
                      Valor recibido a mi(nuestra) entera satisfacción, este pagaré sujeto a la condición de que al no pagarse a su vencimiento será exigible, desde la fecha de su vencimiento de este
                      documento hasta el día de su liquidación, causará intereses moratorios al tipo de 3% mensual, pagadero en esta ciudad justamente con el principal.`}
                    </p>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-left"><strong>Nombre y datos del deudor:</strong></th>
                          <th className="text-center">Aceptamos</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-right">Nombre:</td>
                          <td className="text-left"></td>
                          <td className="text-center"></td>
                        </tr>
                        <tr>
                          <td className="text-right">RUT:</td>
                          <td className="text-left"></td>
                          <td className="text-center">______________________________</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td className="text-left"></td>
                          <td className="text-center">Firma</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td className="text-center">Dirección: C.P.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                  <div className='col-2' style={{ border: "solid 1px" }}>
                    <p className='text-center m-4' style={{ margin: "auto" }}>
                      <strong>REFERENCIAS<br />PARA<br />DEPÓSITO<br />BANCARIO</strong>
                    </p>
                  </div>
                  <div className='col-10 p-2' style={{ border: "solid 1px" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>Para transferencias:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para transferencias:</td>
                          <td>Cuenta: 00000515541</td>
                          <td>CLABE: 113180000005155411</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para depósitos en ventanilla:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: Santander</td>
                          <td>Cuenta: 65506444181</td>
                          <td>CLABE: 014730655064441811</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: HSBC</td>
                          <td>Cuenta: 4062752217</td>
                          <td>CLABE: 021730040627522173</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </td></tr></table>
        }

      {/* Facturas con mas de 10*/}
        {DocLines.length > linesForAllInOne&&
          <>

          {/* Primera hoja de la factura */}
            <table><tr><td>
              <div id="printInvoice" >
                <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
                {DocLines.length > linesForAllInOne && DocLines.length < 71? 
                  <div className='text-right' style={{fontSize:"14px"}}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina 1/2</div>
                  :
                  (DocLines.length > linesfullPage)&&<div className='text-right' style={{fontSize:"14px"}}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina 1/3</div>
                }
                  <div className="row">
                    <div className="col-3">
                      <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />

                      <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />
                        {/* <span className="text-center">{user.Timbra.RFC || ''}</span><br /> */}
                        <strong>Folio: {InfoByFolio.folio || ''}</strong></p>

                      {/* <span className="text-left">Teléfono(s): {user.Branch.Phone || ''}</span> */}
                      <span className="text-left">Teléfono(s): </span>
                      {/* <p className="text-center"><br/>{user.Branch.Address || ''}</p> */}
                      <p className="text-center"><br /></p>
                      {/* <p style={{ fontSize:'11px' }}>COL. C.P.;,.</p> */}
                    </div>
                    <div className="col-9">
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Serie</th>
                            <th className="text-center">Folio</th>
                            <th className="text-center">Número de certificado:</th>
                            <th className="text-center">Fecha - Hora emisión</th>
                            <th className="text-center">Lugar de expedición</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">4</td>
                            <td className="text-center">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                            <td className="text-center">{user.Timbra.Certificate || ''}</td>
                            <td className="text-center">{`${!!DocHeader.DocDate && moment(DocHeader.DocDate).format("YYYY-MM-DD")} ${this.timeFormat()}`}</td>
                            <td className="text-center">{user.Branch.ZipCode || ''}</td>
                            <td className="text-center">{''}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Folio Fiscal:</th>
                            <th className="text-center">Certificado SAT:</th>
                            <th className="text-center">Fecha y Hora de Certificación:</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center" style={{ fontsize: "3vw" }}>{DocHeader.U_UDF_UUID || ''}</td>
                            <td className="text-center">{`30001000000400002495`}</td>
                            <td className="text-center">{`2022-12-27 19:59:49`}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">No. Cliente:</th>
                            <th className="text-center">Uso CFDI</th>
                            <th className="text-center">Asesor de ventas</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">{!!DocHeader.CardCode && DocHeader.CardCode}</td>
                            <td className="text-center">{!!DocHeader.U_FMB_USO_CFDI && DocHeader.U_FMB_USO_CFDI}</td>
                            <td className="text-center">{/*user.U_NAME || ''*/} </td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Tipo Factura</th>
                            <th className="text-center">R.F.C.</th>
                            <th className="text-center">Moneda</th>
                            <th className="text-center">Folio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">Deudores</td>
                            <td className="text-center">
                              {EditableMode === false ? !!DocHeader.LicTradNum && DocHeader.LicTradNum
                                :
                                <input type="text"
                                  placeholder='RUT'
                                  value={EditableDocModel.rfc ? EditableDocModel.rfc : ''}
                                  onChange={(event) => this.OnchangeRFC(event.target.value)}
                                >
                                </input>
                              }
                            </td>
                            <td className="text-center">{!!DocHeader.DocCur && DocHeader.DocCur}</td>
                            <td className="text-center">{InfoByFolio.folio || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='row' style={{ paddingRight: "15px" }}>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center" colSpan={2}>DOMICILIO DE FACTURACIÓN</th>
                          <th className="text-center" colSpan={2} style={{ width: "18.75vw" }}>Forma y método de pago</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ borderLeft: "solid 1px" }}>
                          <td className="text-center" colSpan={2}>
                            {true ?
                              (BillAddress === {} ?
                                (`${DocHeader.BillDirection}`)
                                :
                                (`${BillAddress.County ?? ''}, ${BillAddress.City ?? ''}, ${BillAddress.ZipCode ?? ''}, ${BillAddress.Block ?? ''}, ${BillAddress.Street ?? ''}`)
                              )
                              :
                              <>
                                <table>
                                  <thead>
                                    <tr>
                                      <th className="text-center">CALLE </th>
                                      <th className="text-center">ESTADO </th>
                                      <th className="text-center">CIUDAD </th>
                                      <th className="text-center">COLONIA </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr style={{ borderLeft: "solid 1px" }}>
                                      <td className="text-center">
                                        <input type="text"
                                          placeholder='CALLE'
                                          value={EditableDocModel.street ?? ''}
                                          onChange={(event) => this.OnchangeBillStreet(event.target.value)}
                                        >
                                        </input>
                                      </td>
                                      <td className="text-center">
                                        <input type="text"
                                          placeholder='ESTADO'
                                          value={EditableDocModel.county}
                                          onChange={(event) => this.OnchangeBillCounty(event.target.value)}
                                        >
                                        </input>
                                      </td>
                                      <td className="text-center">
                                        <input type="text" placeholder='CIUDAD'
                                          value={EditableDocModel.city}
                                          onChange={(event) => this.OnchangeBillCity(event.target.value)}
                                        ></input>
                                      </td>
                                      <td className="text-center">
                                        <input type="text" placeholder='COLONIA'
                                          value={EditableDocModel.block}
                                          onChange={(event) => this.OnchangeBillBlock(event.target.value)}
                                        ></input></td>

                                    </tr>
                                  </tbody>
                                </table>
                              </>
                            }
                          </td>
                          <td className="text-center" style={{ border: "solid 1px" }}>{XML.isTimbra ? XML.info._attributes.FormaPago : ''}</td>
                          <td className="text-center" style={{ border: "solid 1px" }}>{XML.isTimbra ? XML.info._attributes.MetodoPago : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">DOMICILIO DE ENTREGA</th>
                          <th className="text-center" style={{ width: "300px" }}>Fecha de vencimiento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ borderLeft: "solid 1px" }}>
                          <td className="text-center">
                            {true ?
                              (ShipAddress === {} ?
                                (`${DocHeader.ShipDirection}`)
                                :
                                (`${ShipAddress.County ?? ''}, ${ShipAddress.City ?? ''}, ${ShipAddress.ZipCode ?? ''}, ${ShipAddress.Block ?? ''}, ${ShipAddress.Street ?? ''}`)
                              )
                              :
                              EditParam1 === true ?
                                <>
                                  <table>
                                    <thead>
                                      <tr>
                                        <th className="text-center">CALLE </th>
                                        <th className="text-center">ESTADO </th>
                                        <th className="text-center">CIUDAD </th>
                                        <th className="text-center">COLONIA </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr style={{ borderLeft: "solid 1px" }}>
                                        <td className="text-center">
                                          <input type="text"
                                            placeholder='CALLE'
                                            value={EditableDocModel.shipStreet ? EditableDocModel.shipStreet : ''}
                                            onChange={(event) => this.OnchangeShipStreet(event.target.value)}
                                          >
                                          </input>
                                        </td>
                                        <td className="text-center">
                                          <input type="text"
                                            placeholder='ESTADO'
                                            value={EditableDocModel.shipCounty}
                                            onChange={(event) => this.OnchangeShipCounty(event.target.value)}
                                          >
                                          </input>
                                        </td>
                                        <td className="text-center">
                                          <input type="text" placeholder='CIUDAD'
                                            value={EditableDocModel.shipCity}
                                            onChange={(event) => this.OnchangeShipCity(event.target.value)}
                                          ></input>
                                        </td>
                                        <td className="text-center">
                                          <input type="text" placeholder='COLONIA'
                                            value={EditableDocModel.shipBlock}
                                            onChange={(event) => this.OnchangeShipBlock(event.target.value)}
                                          ></input></td>

                                      </tr>
                                    </tbody>
                                  </table>
                                </>
                                :
                                ''
                            }
                          </td>
                          <td className="text-center" style={{ border: "solid 1px" }}>{!!DocHeader.DocDueDate && moment(DocHeader.DocDueDate).format("YYYY-MM-DD")}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead>
                        <tr style={{ borderLeft: "solid 1px" }}>
                          <th className="text-center" ></th>
                          <th className="text-center" style={{ width: "300px", background: Datos_Empresa.BackgroundColor, color: "white" }}>Nombre del capturista</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ borderLeft: "solid 1px", borderBottom: "solid 1px" }}>
                          <td className="text-center"></td>
                          <td className="text-center" style={{ border: "solid 1px" }}>{/*user.U_NAME || ''*/}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className='mt-2'>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th>Cant.</th>
                          <th>UMV</th>
                          <th>CVE</th>
                          <th>Cve P/S</th>
                          <th className="text-center">Código</th>
                          <th className="text-center">Descripción</th>
                          <th className="text-center">Tasa</th>
                          <th className="text-right">Precio U</th>
                          <th className="text-right">Importe</th>
                          {/* <th className="text-center">Descuento %</th> */}
                          <th className="text-right">Importe N.</th>
                        </tr>
                      </thead>
                      <tbody style={{ border: "solid 1px" }}>
                        {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                          DocLines.map((docLine) => {//51 es el limite de la primera pagina
                            
                            if (countLines < 52) {
                              countLines++
                              return (
                                <tr style={{ fontSize: '12px' }}>
                                  <td>{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                                  <td>{docLine.SalUnitMsr ?? ''}</td>
                                  <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                                  <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                                  <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                  <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                                  <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                                  <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                                  <td className="text-right">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                                  {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(2) ?? 0}%</td> */}
                                  <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                                </tr>
                              );
                            }else{
                              return("");
                            }
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td></tr></table>
          
          {/* Tablas extra de articulos */}
            {DocLines.length > linesfirstPage && extraTables}
          
          {/* Total */}
            <table><tr><td>
                <div style={(DocLines.length > 38 && DocLines.length < linesfirstPage) || (remainingLines === 0 && DocLines.length > 120)?
                  { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }
                  :
                  { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }
                }>
                  {((DocLines.length === linesfirstPage) || (remainingLines === 0 && DocLines.length > 120))&&
                    <table className='mt-5' style={{fontSize:"14px"}}>
                        <tbody>
                            <tr>
                                <td className='text-left'>
                                    {InfoByFolio.folio}
                                </td>
                                <td className='text-right'>
                                    {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina {totalPages+2}/{totalPages+2}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  }
                  <div className='row mt-2'>
                    <div className='col-8'>
                      <p style={{ marginLeft: "-13px", fontSize: '12px' }}>
                        Comentarios:<br />
                        TODA DEVOLUCIÓN CAUSARÁ UN CARGO DEL 10% DEL TOTAL DE LA FACTURA POR GASTOS ADMINISTRATIVOS.<br />
                        NO ACEPTAMOS DEVOLUCIONES NI CANCELACIONES DESPUÉS DE 7 DÍAS, SIN EXCEPCIONES.<br />
                        EFECTOS FISCALES AL PAGO. ESTA FACTURA SERÁ PAGADA EN UNA SOLA EXHIBICIÓN. <br />
                        <strong>Régimen fiscal del receptor: {(!! DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "" )+ "-" + this.taxSystem(!! DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "")}.</strong><br />
                        {totalLetra} {XML.isTimbra ? XML.info._attributes.Moneda : ''}
                      </p>
                    </div>
                    <div className='col-4'>
                      <table>
                        <tbody style={{ fontSize: '12px' }}>
                          <tr>
                            <td className='text-right'><strong>Subtotal: </strong></td>
                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "6.25vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum)}</td>
                          </tr>
                          {/* <tr>
                            <td className='text-right'><strong>Descuento: %</strong></td>
                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{formatNumber.new(DocHeader.DiscPrcnt) ?? 0}</td>
                          </tr> */}
                          <tr>
                            <td className='text-right'><strong>IVA: </strong></td>
                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</td>
                          </tr>
                          {/* <tr>
                            <td className='text-right'><strong>Retención: </strong></td>
                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{''}</td>
                          </tr> */}
                          <tr>
                            <td className='text-right'><strong>Total: </strong></td>
                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </td></tr></table>
          
          {/* Sellos digitales */}
            <table><tr><td>
                <div style={(DocLines.length > 33 && DocLines.length < 48) || (remainingLines > 66 && remainingLines < linesfullPage)?
                // <div style={(DocLines.length > 33 && DocLines.length < 48) || (DocLines.length > 105 && DocLines.length < 120)?
                  { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }
                  :
                  { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto"}
                }>
                {((DocLines.length > 33 && DocLines.length < 48) || (remainingLines > 66 && remainingLines < linesfullPage))&&
                  <table className='mt-5' style={{fontSize:"14px"}}>
                      <tbody>
                          <tr>
                              <td className='text-left'>
                                  {InfoByFolio.folio}
                              </td>
                              <td className='text-right'>
                                  {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina {totalPages+2}/{totalPages+2}
                              </td>
                          </tr>
                      </tbody>
                  </table>
                }
                  <div className='row mt-2' style={{ paddingRight: "15px" }}>
                    <div className='col-12' style={{ border: "solid 1px" }}>
                      <table>
                        <thead>
                          <tr>
                            <th className="text-center"></th>
                            <th className="text-center">Este documento es una impresión de un comprobante fiscal digital</th>
                            <th className="text-center">Este documento es una representación impresa de un CFDI</th>
                            <th className="text-center"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-left" colSpan={3}>
                              <strong>Sello digital autorizado:</strong><br />
                              <p class='digitalStamp' style={{ marginBottom: "-5px" }}>{DocHeader.U_FMB_SELLO || ''}</p>
                            </td>
                            <td className="text-center" rowSpan={2}>
                              <QRCodeSVG
                                value="https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=FFFFFFFF-C794-4E4F-9BFE-0FEBFC92C301&re=ATN161013BR0&rr=AMA0512139J5&tt=0000000291.550000&fe=VDdANQ=="
                                height={92}
                                width={92}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-left" colSpan={3}><strong>Sello digital SAT:</strong>
                              <p className='digitalStamp' style={{ marginBottom: "-5px" }}>
                                {`Powx0jKFPpsZApizpu2dVF8efd3CF/UeNG47PTo89i8HTt8n+AO5ywVe6CxCYMZwH2LqUTDk7PL9lq1F7a8lnlIL+L7PUADv6sdUifK5N6zrcTrZQLltC4QHIBa/zql1cwTBBAN/2r+leQWpPL0smaM+m35sIPZdUjWag25oPttH33z/fE8LYmAbcbSAp1cyN7dCIYAYz8xJG5QqDPdB+Ea6qiUgdcKyM0z620FHHErRyufKo+KeNe00QvIjzBuq2jWVeb/GDVClpPSPVPQHfvtXlWbvMw2elbsfDlxKShdjc3t++ueNYBjwdvXeyg7Mqa9/RuqwTSNC8pxEPlx/tw==`}
                              </p>
                            </td>

                          </tr>
                          <tr>
                            <td className="text-left" colSpan={4}>
                              <strong>Cadena original:</strong>
                              <p className='digitalStampAlt' style={{ marginBottom: "5px" }}>
                                {`||1.1|92FD9B55-01CE-47C4-8834-48F53D4EF7EA|2022-10-03T12:19:38|PPD101129EA3||pc3vzJctWbvKg+xri/n93rqTUiY3wd66Y9wkDmYW//rHYGXpupxGpsdcH6Lai5tBhARqSN9PjDURGAZXMCeJo7fmcJEtjeJ+WhbIBY94heAW5u3Z2LrZdo+wadQkhrsUWtLSLU1D+9b95nh3S4rEX6tGafB44IAbOAKwVP7e1NryL8ShMdDn2YX3ncTMIz2iEJeZ2FzikExE5o+Fa3noQ6Pmmz6aLS5x8SFTNAGa+pFCSMKl+E7Qg74XhrLsMFvhZDd11nIOO1JJLdzGzXRS3cZz4FtXuFrrXRbn0yIbPrMda3dpyKl6QUaMgXwa9ou1tOrQpNxncOMfAEGK4QYMpw==| 30001000000400002495| |`}
                              </p>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              
            </td></tr></table>
          
          {/* Pagare */}
            <table><tr><td>
                <div style={(DocLines.length > 20 && DocLines.length < 33) || (remainingLines > 53 && remainingLines < 68)?
                  { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }
                  :
                  { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto"}
                }>
                {((DocLines.length > 20 && DocLines.length < 33) || (remainingLines > 53 && remainingLines < 68))&&
                  <table className='mt-5' style={{fontSize:"14px"}}>
                      <tbody>
                          <tr>
                              <td className='text-left'>
                                  {InfoByFolio.folio}
                              </td>
                              <td className='text-right'>
                                  {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina {totalPages+2}/{totalPages+2}
                              </td>
                          </tr>
                      </tbody>
                  </table>
                }
                  <div className='row mt-2' style={{ paddingRight: "15px" }}>
                    <div className='col-12' style={{ border: "solid 1px" }}>
                      <p style={{ fontSize: '11px' }}>
                        Pagaré No. - ? En, a . Bueno por <br />
                        Debo(emos) y pagaré(mos) incondicionalmente por este pagaré a la orden de {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad},<br />
                        , . Fecha pago: <br />
                      </p>
                      <p style={{ fontSize: '11px' }}>
                        La cantidad de:
                        Valor recibido a mi(nuestra) entera satisfacción, este pagaré sujeto a la condición de que al no pagarse a su vencimiento será exigible, desde la fecha de su vencimiento de este
                        documento hasta el día de su liquidación, causará intereses moratorios al tipo de 3% mensual, pagadero en esta ciudad justamente con el principal.
                      </p>
                      <table>
                        <thead>
                          <tr>
                            <th className="text-center"></th>
                            <th className="text-left"><strong>Nombre y datos del deudor:</strong></th>
                            <th className="text-center">Aceptamos</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-right">Nombre:</td>
                            <td className="text-left"></td>
                            <td className="text-center"></td>
                          </tr>
                          <tr>
                            <td className="text-right">RUT:</td>
                            <td className="text-left"></td>
                            <td className="text-center">______________________________</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td className="text-left"></td>
                            <td className="text-center">Firma</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <tbody>
                          <tr>
                            <td className="text-center">Dirección: C.P.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  </div>
              
            </td></tr></table>
          
          {/* Referencias para depositos */}
            <table ><tr><td>
              <div style={(DocLines.length > 10 && DocLines.length < 20) || (remainingLines > 40 && remainingLines < 52)?
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw", marginBottom: "600px" }
                :
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto"}
              }>
                {((DocLines.length > 10 && DocLines.length < 20) || (remainingLines > 40 && remainingLines < 52))&&
                  <table className='mt-5' style={{fontSize:"14px"}}>
                      <tbody>
                          <tr>
                              <td className='text-left'>
                                  {InfoByFolio.folio}
                              </td>
                              <td className='text-right'>
                                  {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina {totalPages+2}/{totalPages+2}
                              </td>
                          </tr>
                      </tbody>
                  </table>
                }
                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                  <div className='col-2' style={{ border: "solid 1px" }}>
                    <p className='text-center m-4' style={{ margin: "auto" }}>
                      <strong>REFERENCIAS<br />PARA<br />DEPÓSITO<br />BANCARIO</strong>
                    </p>
                  </div>
                  <div className='col-10 p-2' style={{ border: "solid 1px" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>Para transferencias:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para transferencias:</td>
                          <td>Cuenta: 00000515541</td>
                          <td>CLABE: 113180000005155411</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para depósitos en ventanilla:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: Santander</td>
                          <td>Cuenta: 65506444181</td>
                          <td>CLABE: 014730655064441811</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: HSBC</td>
                          <td>Cuenta: 4062752217</td>
                          <td>CLABE: 021730040627522173</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td></tr></table>
          </>
        }
      </>
    )
  }
}

export default AdvancePaymentInvoiceDoc